module.exports = __webpack_public_path__ + "static/new-list-img-a2a9a2ff23308c718459c02151a05ce3.png";